<template>
    <el-card shadow="never" class="aui-card--fill" @focus="showmsg()">
		<el-row style="background-color: #F3F4F4;">
				 <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
					 <img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/usericon.png" /></el-col>
				 <el-col :xs="24" :md="18">

					<el-form style="text-align: right;">
						<el-form-item>
							<el-button class="addBtn" style="left: 1515px;" type="info" @click="getInfo()">刷新</el-button>
						</el-form-item>
					</el-form>
				 </el-col>
		</el-row>
        <el-form :model="dataForm" style="border-bottom: 1px solid #D7D7D7;padding-top: 20px;" :rules="dataRule" ref="dataForm"
                 label-width="120px" >

            <el-row>
                <el-col :sm="12" :lg="6">
                    <el-form-item label="姓名" prop="realName">
                        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.realName" placeholder="姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :lg="6">
                    <el-form-item label="身份证号" prop="idCard">
                        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.idCard" placeholder="身份证号"></el-input>
                    </el-form-item>
                </el-col>
            	<el-col :sm="12" :lg="6">
            		<el-form-item label="出生日期" prop="birthDay">
            		    <el-date-picker style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.birthDay" type="datetime" placeholder="出生日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss">
            		    </el-date-picker>
            		</el-form-item>
            	</el-col>
            	<el-col :sm="12" :lg="6">
            		<el-form-item label="最高学历" prop="education">
            		    <ren-select style="width: 80%;" :isDisabled="dataForm.status > 0?true:false" v-model="dataForm.education" dict-type="education" placeholder="选择学历"></ren-select>
            		</el-form-item>
            	</el-col>
            </el-row>
            <el-row>
            	<el-col :sm="12" :lg="6">
            	    <el-form-item label="开户银行" prop="bankName">
            	        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.bankName" placeholder="开户银行"></el-input>
            	    </el-form-item>
            	</el-col>
            	<el-col :sm="12" :lg="6">
            	    <el-form-item label="银行账户" prop="bankAccount">
            	        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.bankAccount" placeholder="银行账户"></el-input>
            	    </el-form-item>
            	</el-col>
                <el-col :sm="12" :lg="6">
                    <el-form-item label="手机号" prop="phone">
                        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.phone" placeholder="手机号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :lg="6">
                    <el-form-item label="联系地址" prop="address">
                        <el-input style="width: 80%;" type="textarea" :disabled="dataForm.status > 0?true:false" v-model="dataForm.address" placeholder="联系地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :sm="12" :lg="6">
                    <el-form-item label="支付宝账号" prop="alipayLoginId">
                        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.alipayLoginId" placeholder="支付宝账号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <!-- <el-col :sm="12" :lg="6">
                    <el-form-item label="邮箱" prop="email">
                        <el-input style="width: 80%;" :disabled="dataForm.status > 0?true:false" v-model="dataForm.email" placeholder="邮箱"></el-input>
                    </el-form-item>
                </el-col> -->
            	<el-col :sm="12" :lg="6">
            	    <el-form-item label="四要素认证" prop="isKeyElement">
            			<el-checkbox :disabled="dataForm.status > 0?true:false" true-label="1" v-model="dataForm.isKeyElement"></el-checkbox>
            	    </el-form-item>
            	</el-col>
            	<el-col :sm="12" :lg="6">
            	    <el-form-item label="实人认证" prop="isRealName">
            			<el-checkbox :disabled="dataForm.status > 0?true:false" true-label="1" v-model="dataForm.isRealName"></el-checkbox>
            	    </el-form-item>
            	</el-col>
            </el-row>
            <el-row>
            	<el-col :sm="12" :lg="12">
            		<!-- <el-form-item label="经营项目" prop="businessItem">
            			<el-input :disabled="dataForm.status > 0?true:false" v-model="dataForm.businessItem" rows="4"  maxlength="200" show-word-limit type="textarea" placeholder="经营项目" style="border: none;width:90%"></el-input>
            		</el-form-item> -->
                <el-form-item label="经营项目" prop="businessItem">
                <!-- <ren-select
                  style="width: 80%"
                  :isDisabled="true"
                  v-model="dataForm.businessItem"
                  dict-type="businessItems"
                  placeholder="经营项目"
                ></ren-select> -->
                <el-select v-model="dataForm.businessItem" @input="$emit('input', $event)" clearable filterable
                      :disabled="dataForm.isRealName != 1 ? true : false">
                  <el-option :label="data" v-for="data in dataForm.businessItems" :key="data" :value="data">
                      {{data}}
                  </el-option>
              </el-select>
              </el-form-item>
            	</el-col>
            	<el-col :sm="12" :lg="12" v-if="dataForm.videoAuthPath != null">
            		<el-form-item label="认证视频">
            			<div id="myvideo"></div>
            		</el-form-item>
            	</el-col>
            </el-row>
            <el-row>
                <el-col :sm="12" :lg="12">
            		<el-form-item label="证照材料">
            			<el-row>
            				<el-col :xs="12" :lg="12">
            					<el-form-item prop="idcardFacePath">
            					<el-upload
            					        ref="upload"
            					        :action="url"
            					        class="avatar-uploader"
            					        :multiple="multiple"
            					        :before-upload="beforeUploadHandle"
            					        :on-success="beforesuccessHandle"
            					        :auto-upload="true"
            					        :show-file-list="false"
            							 :disabled="dataForm.status > 0?true:false"
            					>
            					    <img @click="yulan(dataForm.idcardFacePath)" v-if="dataForm.idcardFacePath" :src="dataForm.idcardFacePath" class="avatar" style="width: 100%;height: 192px;">
            					    <i v-else :style="{backgroundImage:'url('+require('../../../assets/img/cardFront.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
            					    <div slot="tip" class="el-upload__tip" style="line-height: 20px;margin-top: 0;width: 100%;height: 192px;">{{tip1}}</div>
            					</el-upload>

            					</el-form-item>

            				</el-col>
            				<el-col :xs="12" :lg="12">
            					<el-form-item prop="idcardBackPath">
            					<el-upload
            					        ref="upload"
            					        :action="url"
            					        class="avatar-uploader"
            					        :multiple="multiple"
            					        :before-upload="beforeUploadHandle"
            					        :on-success="backsuccessHandle"
            					        :auto-upload="true"
            					        :show-file-list="false"
            							    :disabled="dataForm.status > 0?true:false"
            					>
            					    <img @click="yulan(dataForm.idcardBackPath)" v-if="dataForm.idcardBackPath" :src="dataForm.idcardBackPath" class="avatar" style="width: 100%;height: 192px;">
            					    <i v-else :style="{backgroundImage:'url('+require('../../../assets/img/cardBack.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
            					    <div slot="tip" class="el-upload__tip" style="line-height: 20px;margin-top: 0;width: 100%;height: 192px;">{{tip2}}</div>
            					</el-upload>

            					</el-form-item>
            				</el-col>
            			</el-row>
            		</el-form-item>
                </el-col>
            	<el-col :sm="24" :lg="8">
            		<el-form-item label="电子签章">
            			<el-upload
            			        ref="upload"
            			        :action="url"
            			        class="avatar-uploader"
            			        :multiple="multiple"
            			        :before-upload="beforeUploadHandle"
            			        :on-success="beforesuccessHandlesignPath"
            			        :auto-upload="true"
            			        :show-file-list="false"
            					 :disabled="dataForm.status > 0?true:false"
            			>
            			    <img @click="yulan(dataForm.signPath)" v-if="dataForm.signPath" :src="dataForm.signPath" class="avatar" style="width: 100%;height: 134px;">
            			    <i v-else :style="{backgroundImage:'url('+require('../../../assets/img/yingye.png')+')',backgroundSize:'100% 100%',backgroundRepeat:'no-repeat',color:'#315DD1'}" class="el-icon-circle-plus avatar-uploader-icon"></i>
            			    <div slot="tip" class="el-upload__tip" style="line-height: 20px;margin-top: 0;">电子签章</div>
            			</el-upload>
            		</el-form-item>
            	</el-col>
            </el-row>
        </el-form>

		<div v-if="dataForm.processList.length > 0">
			<h4 style="margin-left: 30px;font-weight: bold;padding-top:20px;">用户信息状态</h4>
			<p v-for="item in dataForm.processList" style="margin: 0;line-height: 36px;"><span style="width: 8px;height: 8px;border-radius: 4px;background-color: #5389DF;display: inline-block;margin-left: 30px;margin-right: 10px;">
			</span>{{item.createDate}}&nbsp;&nbsp;&nbsp;{{item.action}}</p>
		</div>
    </el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import ossUploadImg from '../oss/oss-upload-img'
import Cookies from 'js-cookie'
import Player from 'xgplayer';
import {
  isEmail,
} from '@/utils/validate'
export default {
  components: {
		    ossUploadImg
  },
  data () {
    return {
      multiple: false,
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      visible: false,
      tip1: '身份证正面照',
      tip2: '身份证反面照',
      userStatus: 1,
      dataForm: {
        realName: '',
        education: '',
        idCard: '',
        birthDay: '',
        phone: '',
        alipayLoginId:'',
        email: '',
        address: '',
        idcardFacePath: '',
        idcardBackPath: '',
        signPath: '',
        isEnable: 1,
        status: 0,
        userId: '',
        processList: [],
        bankName: '',
        bankAccount: '',
        isKeyElement: '',
        isRealName: '',
        videoAuthPath: ''
      }
    }
  },
  computed: {
    dataRule () {
      var checknum = (rule, value, callback) => {
        if (!isNumber(value)) {
          callback(new Error('请输入数字值'))
        }
        callback()
      }
      var checkfloat = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入数字值,并且最多两位小数'))
        }
      }
      var checkphone = (rule, value, callback) => {
        if (/^1\d{10}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入手机号'))
        }
      }
      var checkAlipayLoginId = (rule,value,callback) => {
        if((/^(?:1[3-9]\d{9}|[a-zA-Z\d._-]*\@[a-zA-Z\d.-]{1,10}\.[a-zA-Z\d]{1,20})$/.test(value))){
          callback()
        }else {
          callback(new Error('请填写正确的支付宝账号'))
        }
      }
      var checkcard = (rule, value, callback) => {
        if (/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入身份证号'))
        }
      }
      var checkbank = (rule, value, callback) => {
        // if (/^([A-Za-z0-9]{9}|[A-Za-z0-9]{17}|[A-Za-z0-9]{19})$/.test(value)) {
        if(/^\d{1,30}$/.test(value) ){
          callback()
        } else {
          callback(new Error('请输入卡号'))
        }
      }

      var checkNumtwo = (rule, value, callback) => {
        if (/^[A-Za-z0-9]{7,20}$/.test(value)) {
          callback()
        } else {
          callback(new Error('社会信用代码格式错误'))
        }
      }
      var validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.email') })))
        }
        callback()
      }
      return {
        signPath: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        bankName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        bankAccount: [{
          required: true,
          message: '请输入卡号',
          trigger: 'blur'
        },{ message: '银行卡号错误，请检查位数'
        ,validator: checkbank,
        trigger: 'blur'}],
        realName: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        education: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        idCard: [{ required: true, message: '请输入身份证号', validator: checkcard, trigger: 'blur' }],
        birthDay: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        phone: [{ required: true, message: '输入正确的电话号码', validator: checkphone, trigger: 'blur' }],
        alipayLoginId: [{ required: true, message: '输入正确的支付宝账号', validator: checkAlipayLoginId, trigger: 'blur' }],
        // email: [{ required: true, message: '请输入邮箱', validator: validateEmail, trigger: 'blur' }],
        address: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        idcardFacePath: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        idcardBackPath: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    // 上传之前
    beforeUploadHandle (file) {
			    if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
			      this.$message.error(this.$t('upload.tip', { 'format': 'jpg、png、gif' }))
			      return false
			    }
      if (file.size / 1024 / 1024 > 30) {
							  this.$message.error('文件太大，只能上传30MB以内的文件')
							  return false
      }
    },
    // 上传成功
    beforesuccessHandle (data, file) {
			    this.dataForm.idcardFacePath = data.data.url
    },
    backsuccessHandle (data, file) {
			    this.dataForm.idcardBackPath = data.data.url
    },
    beforesuccessHandlesignPath (data, file) {
			    this.dataForm.signPath = data.data.url
    },
    // 保存信息
    saveHandle () {
      this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/info/user/', this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
      }).catch(() => {
      })
    },
    getInfo () {
      this.$http.get(`/sys/user/info`).then(({ data: res }) => {
				    if (res.code !== 0) {
				        return this.$message({
								  message: res.msg,
								  type: 'error',
								  duration: 500
          })
				    }
				    this.$http.get(`/sys/plat/info/user/getInfoByUserId?userId=` + res.data.id).then(({ data: res }) => {
				        if (res.code !== 0) {
				            return this.$message({
                      message: res.msg,
                      type: 'error',
                      duration: 500
                    })
                }
                if(res.data.isKeyElement==1){
                  res.data.isKeyElement=true
                }else{
                  res.data.isKeyElement=false
                }
                if(res.data.isRealName==1){
                  res.data.isRealName=true
                }else{
                  res.data.isRealName=false
                }
				        this.dataForm = {
				            ...this.dataForm,
				            ...res.data
                }
          let player = new Player({
            id: 'myvideo',
            url: this.dataForm.videoAuthPath,
            width: 300,
            height: 150
          })
          this.showmsg()
				    }).catch(() => {
				    })
      }).catch(() => {
      })
    },
    refresh () {
      this.getInfo()
    },
    yulan (url) {
      window.open(url, url)
    },
    showmsg () {
      if (this.dataForm.userStatus == 2) {
        return false
      }
      let alertStr = "请扫描首页二维码，完善您的个人资料";
      if(this.dataForm.isRealName != 1){
        alertStr = "请扫描首页二维码，完成实名认证";
      }else{
        if(this.dataForm.bankAccount == null){
          alertStr = "请扫描首页二维码，填写您的银行卡信息";
          }
      }
      
      this.$alert(alertStr, this.$t('prompt.title'), {
				  confirmButtonText: this.$t('confirm'),
        callback: action => {
					  this.$router.push({ name: 'home' })
				  }
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
            	function (inStatus) {
            		this.$refs['dataForm'].validate(valid => {
            			if (!valid) {
            				return false
            			}
            			this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/info/user', this.dataForm)
            				.then(({ data: res }) => {
            					if (res.code !== 0) {
            						return this.$message.error(res.msg)
            					}
            					this.$message({
            						message: this.$t('prompt.success'),
            						type: 'success',
            						duration: 500,
            						onClose: () => {
                  this.getInfo()
            						}
            					})
            				})
            				.catch(() => {})
            		})
            	},
            	1000,
            	{ leading: true, trailing: false }
    )
  }
}
</script>
